import React, { Component } from "react";
import "./representation.css";
import Header from "../../components/page/header";
import Footer from "../../components/page/footer";
import map from "../../assets/images/general/attract_agency_havayar.jpg";
import { getProvinces } from "../../constants/provinces-constant";
import { getProvinceAgent } from "../../constants/provinces-constant";
import DropDownWhiteStyle from "../../components/dropdown/dropDownWhiteStyle";
import { Fragment } from "react";

export default class representation extends Component {

    state = {
        proviences: [],
        isProviencesSelected: false,
        selectedProvience: "null",
        provinceName: "",
        agentCount: "1",
        company: "دفتر مرکزی تهران",
        provinceId: "",
        address: "ایران، تهران، خیابان ولیعصر، نرسیده به میدان ونک، خیابان ۱۴ (گاندی) پلاک ۱۲، ساختمان هوایار",
        email: "info@havayar.com",
        tel: "۰۲۱-۸۸۲۰۲۴۲۴",
        num: "۲۲۰۸",
        agent: "منطقه 2 آقای رضا احمدوند - منطقه 3 آقای علیرضا گلستانه و حسین هاشمی",
        agentmobile: " - گلستانه 09121750854 - هاشمی 09125493918 احمدوند 09194646836",
        expert: "خانم پاپی",
    };

    componentDidMount() {
        this.setState({ proviences: [...getProvinces()] });
    };

    handleProviencesSelect = async (province) => {
        var res = await getProvinceAgent(province.value);
        this.replaceProviencesInfo(res[0]);
        console.log("res : ", res[0]);
    };

    replaceProviencesInfo(province) {
        this.setState({ provinceName: province.label }, () => { });
        this.setState({ company: province.company }, () => { });
        this.setState({ tel: province.Tel }, () => { });
        this.setState({ num: province.num }, () => { });
        this.setState({ address: province.Address }, () => { });
        this.setState({ email: province.Email }, () => { });
        this.setState({ agent: province.agent }, () => { });
        this.setState({ agentCount: province.agentCount }, () => { });
        this.setState({ expert: province.expert }, () => { });
        this.setState({ expertmobile: province.expertmobile }, () => { });
        this.setState({ agentmobile: province.agentmobile }, () => { });
    }

    render() {
        return (
            <Fragment>
                <Header />
                <section className="container education-list">
                <div className="container">
                    <div className="mb-4 mt-3">
                        <DropDownWhiteStyle
                            items={this.state.proviences}
                            placeholder="استان"
                            onItemSelect={this.handleProviencesSelect}
                        />
                    </div>
                </div>
                <section className="container">
                    <div className="row hrow headbox" id="cat_01">
                        <h3 className="title">{this.state.provinceName}</h3>
                        <span className="subtitle">{this.state.agentCount} نمایندگی در استان</span>
                    </div>
                    <div className="row">
                        <div className="Representation-item">
                                <img src={map} className="img-fluid" alt="goldMedal" />
                            <div className="map-info">
                                <h3>  {this.state.provinceName} شرکت : {this.state.company}</h3>
                                <dl className="row">
                                    <dt className="col-sm-3" style={{ color: "red" }}>آدرس :</dt>
                                    <dt className="col-sm-9">{this.state.address}</dt>
                                    <dt className="col-sm-3" style={{ color: "red" }}>ایمیل:</dt>
                                    <dt className="col-sm-9">{this.state.email}</dt>
                                    <dt className="col-sm-3" style={{ color: "red" }}>نام نماینده :</dt>
                                    <dt className="col-sm-9">{this.state.agent}</dt>
                                    <dt className="col-sm-3" style={{ color: "red" }}>مسئول منطقه :</dt>
                                    <dt className="col-sm-9">{this.state.expert}</dt>
                                    <dt className="col-sm-3" style={{ color: "red" }}>داخلی :</dt>
                                    <dd className="col-sm-9">{this.state.num}</dd>
                                    <dt className="col-sm-3" style={{ color: "red" }}>تلفن نماینده :</dt>
                                    <dd className="col-sm-9">{this.state.tel}</dd>
                                    <dt className="col-sm-3" style={{ color: "red" }}>همراه نماینده :</dt>
                                    <dd className="col-sm-5">{this.state.agentmobile}</dd>
                                </dl>
                            </div>
                        </div>
                    </div>
                    </section>
                </section>
                <Footer />
            </Fragment>
        );
    }
}
